/*
 *  -----------------------------------------------------------------------
 *    <copyright file="custom-tooltip.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import React from 'react';
import { withStyles } from 'tss-react/mui';

const DarkTooltip = withStyles(Tooltip, (theme) => ({
    tooltip: {
        backgroundColor: '#212121',
        color: theme.palette.common.white,
        fontSize: 13,
        fontWeight: 400,
        fontFamily: 'Montserrat',
        padding: '10px 15px',
        height: 180,
        maxWidth: 450,
    },
    arrow: {
        color: '#212121',
    },
    popper: {
        // Casting as Typescript seems to have an issue with the type overlap otherwise
        pointerEvents: 'all' as 'all',
    },
}));

const CustomTooltip = (props: TooltipProps) => (
    <DarkTooltip
        arrow
        placement="top"
        slotProps={{ popper: { disablePortal: true, placement: 'top' } }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        {...props}
    />
);

export default CustomTooltip;
